import {
	TEACHER_PAGES_SCHEDULE_VIEW,
	COURSE,
	COURSE_GROUP,
	USERS_LIST,
	DATATABLE_EXPORT,
} from "../../../../../Config/ApiUrl";

export const Schema = {
	components: {},

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			tableId: "schedule-table",
			rowData: {},
			formId: "schedule-form",
			tableColumns: [
				{
					title: "Date",
					type: "custom-html",
					key: "schedule",
					modifier: (value) =>
						JSON.parse(value)
							? `${JSON.parse(value).date}`
							: "-",
				},
				{
					title: "Learning Program",
					type: "text",
					key: "learning_program",
				},
				{
					title: "Note",
					type: "text",
					key: "class_note",
				},
				{
					title: "Class Name",
					type: "text",
					key: "course_name",
				},
				{
					title: "Level",
					type: "text",
					key: "product_level_code",
				},
				{
					title: "Product Name",
					type: "text",
					key: "product_name",
				},
				{
					title: "Qty Student Plan",
					type: "text",
					key: "qty_student_plan",
				},
				{
					title: "Qty Student Paid",
					type: "text",
					key: "qty_student_paid",
				},
				{
					title: "星期一",
					type: "custom-html",
					key: "schedule",
					modifier: (value) =>
						JSON.parse(value) && JSON.parse(value).day === "Monday"
							? `${JSON.parse(value).time_start.slice(0, 5)} - ${
									JSON.parse(value).time_end.slice(0, 5)
							  }`
							: "-",
				},
				{
					title: "星期二",
					type: "custom-html",
					key: "schedule",
					modifier: (value) =>
						JSON.parse(value) && JSON.parse(value).day === "Tuesday"
							? `${JSON.parse(value).time_start.slice(0, 5)} - ${
									JSON.parse(value).time_end.slice(0, 5)
							  }`
							: "-",
				},
				{
					title: "星期三",
					type: "custom-html",
					key: "schedule",
					modifier: (value) =>
						JSON.parse(value) &&
						JSON.parse(value).day === "Wednesday"
							? `${JSON.parse(value).time_start.slice(0, 5)} - ${
									JSON.parse(value).time_end.slice(0, 5)
							  }`
							: "-",
				},
				{
					title: "星期四",
					type: "custom-html",
					key: "schedule",
					modifier: (value) =>
						JSON.parse(value) &&
						JSON.parse(value).day === "Thursday"
							? `${JSON.parse(value).time_start.slice(0, 5)} - ${
									JSON.parse(value).time_end.slice(0, 5)
							  }`
							: "-",
				},
				{
					title: "星期五",
					type: "custom-html",
					key: "schedule",
					modifier: (value) =>
						JSON.parse(value) && JSON.parse(value).day === "Friday"
							? `${JSON.parse(value).time_start.slice(0, 5)} - ${
									JSON.parse(value).time_end.slice(0, 5)
							  }`
							: "-",
				},
				{
					title: "星期六",
					type: "custom-html",
					key: "schedule",
					modifier: (value) =>
						JSON.parse(value) &&
						JSON.parse(value).day === "Saturday"
							? `${JSON.parse(value).time_start.slice(0, 5)} - ${
									JSON.parse(value).time_end.slice(0, 5)
							  }`
							: "-",
				},
			],
			ENDPOINT: TEACHER_PAGES_SCHEDULE_VIEW,
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "Schedule",
				url: TEACHER_PAGES_SCHEDULE_VIEW,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: false,
				columns: [],
				actions: [
					{
						title: this.$t("view"),
						icon: "eye",
						type: "viewAndHideTeacherPagesStudentSchedule",
					},
				],
				filters: [
					{
						title: "Course",
						type: "search-and-select-filter",
						key: "course_id",
						settings: {
							url: `/${COURSE}`, // this url will hit every search action
							modifire: (v) => {
								return { id: v.id, course_name: v.course_name };
							},
							per_page: 10, // default 10, you can change it any number. min 10 encourage to use
							queryName: "search", // default 'search', this key will use for query build link '../endpoind?last_name=shi&moreparam...'
							loader: "app-pre-loader", // default app-overlay-loder
							multiple: true, // default false, if you need to select multiple item so make it true
							params: {
								is_active: true,
							}, // params object will be appended with your url after search param like '../endpoint?last_name=shishir&type=type1&isWanted=true'
						},
						listValueField: "course_name",
					},
					{
						title: "Course Group",
						type: "search-and-select-filter",
						key: "course_group_id",
						settings: {
							url: `/${COURSE_GROUP}`, // this url will hit every search action
							modifire: (v) => {
								return {
									id: v.id,
									course_group_name: v.course_group_name,
								};
							},
							per_page: 10, // default 10, you can change it any number. min 10 encourage to use
							queryName: "search", // default 'search', this key will use for query build link '../endpoind?last_name=shi&moreparam...'
							loader: "app-pre-loader", // default app-overlay-loder
							multiple: true, // default false, if you need to select multiple item so make it true
							params: {
								is_active: true,
							}, // params object will be appended with your url after search param like '../endpoint?last_name=shishir&type=type1&isWanted=true'
						},
						listValueField: "course_group_name",
					},
					{
						title: "Teacher",
						type: "search-and-select-filter",
						key: "teach_id",
						settings: {
							url: `/${USERS_LIST}`, // this url will hit every search action
							modifire: (v) => {
								return {
									id: v.id,
									full_name: v.full_name,
								};
							},
							per_page: 10, // default 10, you can change it any number. min 10 encourage to use
							queryName: "search", // default 'search', this key will use for query build link '../endpoind?last_name=shi&moreparam...'
							loader: "app-pre-loader", // default app-overlay-loder
							multiple: true, // default false, if you need to select multiple item so make it true
							params: {
								is_active: true,
							}, // params object will be appended with your url after search param like '../endpoint?last_name=shishir&type=type1&isWanted=true'
						},
						listValueField: "full_name",
					},
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 5,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		/**
		 * Delete confirmed $emit Form confirmation modal
		 */
		onDelete() {
			let url = `${this.ENDPOINT}/${this.rowData.id}`;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.onCancelDelete();
					this.$toastr.s(response.data.message);
					// this.searchAndSelectFilterOptions();
				})
				.catch(({ err }) => {})
				.finally(() => this.$hub.$emit(`reload-${this.tableId}`));
		},
		onCancelDelete() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
	},
};
